import { render, staticRenderFns } from "./AddRtWr.vue?vue&type=template&id=06b9ae5e"
import script from "./AddRtWr.vue?vue&type=script&lang=js"
export * from "./AddRtWr.vue?vue&type=script&lang=js"
import style0 from "./AddRtWr.vue?vue&type=style&index=0&id=06b9ae5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports